import { useEffect, useReducer } from "react";

type Props = {
  timer: { getRemaining: () => number };
};

// 카운트다운 남은 시간(초) 표시
// 매초 이 컴포넌트만 다시 그려서, 카운트다운 표시 때문에 페이지 전체가 리렌더되지 않게 한다.
const CountdownText = ({ timer }: Props) => {
  const [, forceRender] = useReducer((count: number) => count + 1, 0);

  useEffect(() => {
    const intervalId = setInterval(forceRender, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return <>{timer.getRemaining().toString().padStart(2, "0")}</>;
};

export default CountdownText;
